import * as ObjectSegFilterTypes from 'customer-data-filters-ui/converters/objectSeg/ObjectSegFilterTypes';
import * as OperatorTypes from '../ObjectSegOperatorTypes';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import invariant from 'react-utils/invariant';
import protocol from 'transmute/protocol';
import { toMultipleRefinementFilter } from '../multipleRefinementsUtils';
const CtaToCtaPlacement = {
  [OperatorTypes.HAS_CLICKED_CTA]: OperatorTypes.HAS_CLICKED_CTA_PLACEMENT,
  [OperatorTypes.HAS_NOT_CLICKED_CTA]: OperatorTypes.HAS_NOT_CLICKED_CTA_PLACEMENT,
  [OperatorTypes.HAS_OPENED_CTA]: OperatorTypes.HAS_OPENED_CTA_PLACEMENT,
  [OperatorTypes.HAS_NOT_OPENED_CTA]: OperatorTypes.HAS_NOT_OPENED_CTA_PLACEMENT
};
const _toCtaFilter = (operatorName, operator) => {
  const operatorValue = get('value', operator);
  const filter = {
    filterType: ObjectSegFilterTypes.CTA,
    operator: operatorName,
    ctaName: operatorValue
  };
  if (operatorValue === __ANY_CTA) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    filter.operator = CtaToCtaPlacement[operatorName];
    filter.ctaName = getIn(['field', 'name'], operator);
  }
  return Object.assign({}, filter, toMultipleRefinementFilter(operator, false));
};
const invalidOperator = operator => {
  invariant(false, 'cannot convert Operator "%s" to Cta filter', operator.name);
};
const toCtaFilter = protocol({
  name: 'toCtaFilter',
  args: [protocol.TYPE],
  fallback: invalidOperator
});
toCtaFilter.implement(Operators.CtaHasClicked, operator => _toCtaFilter(OperatorTypes.HAS_CLICKED_CTA, operator));
toCtaFilter.implement(Operators.CtaHasNotClicked, operator => _toCtaFilter(OperatorTypes.HAS_NOT_CLICKED_CTA, operator));
toCtaFilter.implement(Operators.CtaHasSeen, operator => _toCtaFilter(OperatorTypes.HAS_OPENED_CTA, operator));
toCtaFilter.implement(Operators.CtaHasNotSeen, operator => _toCtaFilter(OperatorTypes.HAS_NOT_OPENED_CTA, operator));
export default toCtaFilter;